import { render, staticRenderFns } from "./WithdrawCryptoExchangeForm.vue?vue&type=template&id=a40e6160&scoped=true"
import script from "./WithdrawCryptoExchangeForm.vue?vue&type=script&lang=js"
export * from "./WithdrawCryptoExchangeForm.vue?vue&type=script&lang=js"
import style0 from "./WithdrawCryptoExchangeForm.vue?vue&type=style&index=0&id=a40e6160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40e6160",
  null
  
)

export default component.exports